import _ from "lodash";

export default {    
    alert: state => _.cloneDeep(state.alert),
};